//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";

const WORK_TYPE_LABELS = {
  "visa-renewal": "Visa Renewal",
  "visa-cancel": "Visa Cancellation",
  "wp-new": "New Work Permit",
  "wp-renewal": "Work Permit Renewal",
  "wp-cancel": "Work Permit Cancellation",
  "wp-urgent": "Urgent Work Permit Extension",
  "vwp-renewal": "Visa & Work Permit Renewal",
  "ltr-new": "New LTR",
  "ltr-renewal": "LTR Renewal",
  "ltr-cancel": "LTR Cancellation",
  pcc: "Police Clearance Certificate",
  legal: "Legalization",
  notarial: "Notarial Services",
  "90day": "90-Day Report",
  annual: "Annual Report",
  toe: "Transfer of Endorsement",
  tax: "Personal Income Tax Filing",
  other: "Others",
};
const TH_DAYS = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
const TH_MONTHS = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];

export default {
  name: "ImOverview",
  data() {
    return {
      workTypePage: 1,
       urgentPage: 1,
       expiringPage: 1,
      expiringPageCount: 0,
      expiringHeaders: [
        { text: "File No.", value: "file_no_display" },
        { text: "Applicant", value: "applicant" },
        { text: "Expiry", value: "expiry_date", align: "end" },
      ],
      loading: false,
      today: null,
      summary: {
        pending: 0, overdue: 0, due_today: 0, due_7: 0,
        ongoing: 0, complete: 0, active_matters: 0,
      },
      urgent: [],
      workTypeSummary: [],
      expiring: [],
      statCards: [
        { key: "overdue", label: "Overdue", sub: "เกินกำหนดแล้ว", color: "#dc2626" },
        { key: "due_today", label: "Due Today", sub: "ครบกำหนดวันนี้", color: "#ea580c" },
        { key: "due_7", label: "Due ≤ 7 วัน", sub: "กำลังจะถึงกำหนด", color: "#d97706" },
        { key: "ongoing", label: "Ongoing", sub: "ดำเนินการอยู่", color: "#2563eb",
          to: { path: "/immigration-docket", query: { status: "ongoing" } } },
        { key: "complete", label: "Complete", sub: "เสร็จสิ้น", color: "#16a34a",
          to: { path: "/immigration-docket", query: { status: "complete" } } },
        { key: "active_matters", label: "Active Matters", sub: "แฟ้มที่ Active", color: "#9ca3af",
          to: { path: "/immigration-matter", query: { status: "active" }} },
      ],
    };
  },
  computed: {
    workTypePageCount() {
      return Math.ceil(this.workTypeSummary.length / 5);
    },
    workTypePaged() {
      const start = (this.workTypePage - 1) * 5;
      return this.workTypeSummary.slice(start, start + 5);
    },
     urgentPageCount() {
      return Math.ceil(this.urgent.length / 6);
    },
    urgentPaged() {
      const start = (this.urgentPage - 1) * 6;
      return this.urgent.slice(start, start + 6);
    },
    todayText() {
      if (!this.today) return "";
      const [y, m, d] = this.today.split("-").map(Number);
      const dt = new Date(y, m - 1, d);
      return `วัน${TH_DAYS[dt.getDay()]}ที่ ${d} ${TH_MONTHS[m - 1]} ${y}`;
    },
    expiringRows() {
      return this.expiring.map((e) => ({ ...e, key: `${e.id}-${e.type}` }));
    },
  },
  async mounted() {
    this.$store.state.navMenu = true;
    if (!(localStorage.getItem(server.USER_ID) && api.isLoggedIn())) {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
      return;
    }
    await this.loadData();
    this.$hideLoader();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const { data } = await api.getOverviewim_docket(
          localStorage.getItem(server.COMPANYID),
        );
        this.today = data.today;
        this.summary = data.summary;
        this.urgent = data.urgent;
        this.workTypeSummary = data.work_type_summary;
        this.expiring = data.expiring;
      } catch (error) {
        console.error("Error loading overview:", error);
      } finally {
        this.loading = false;
      }
    },
    workTypeLabel(v) {
      return WORK_TYPE_LABELS[v] || v;
    },
    deadlineLabel(u) {
      return (
        { visa: "Visa Expiry", wp: "Work Permit Expiry", ltr: "LTR Expiry" }[u.deadline_type] ||
        this.workTypeLabel(u.work_type)
      );
    },
    deadlineIcon(type) {
      return (
        { visa: "mdi-passport", wp: "mdi-card-account-details", ltr: "mdi-card-account-details-star" }[type] ||
        "mdi-calendar-alert"
      );
    },
    level(days) {
      if (days < 0) return "overdue";
      if (days <= 7) return "warn";
      if (days <= 15) return "soon";
      return "";
    },
    levelColor(days) {
      return { overdue: "#dc2626", warn: "#d97706", info: "#2563eb", soon: "#2563eb" }[this.level(days)];
    },
    fmtDate(s, short = false) {
      if (!s) return "-";
      const [y, m, d] = s.split("-");
      return short ? `${d}/${m}` : `${d}/${m}/${y}`;
    },
  },
};
